var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"background-video-container"},[_c('video',{staticClass:"background-video",attrs:{"autoplay":"","muted":"","loop":""},domProps:{"muted":true}},[_c('source',{attrs:{"src":_vm.videoSrc,"type":"video/mp4"}}),_vm._v(" Your browser does not support the video tag. ")]),_c('div',{staticClass:"content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }